<script setup lang="ts"></script>

<template>
	<div class="relative h-full overflow-hidden">
		<main
			class="h-full fixed inset-0 overflow-auto grid place-items-center"
		>
			<slot></slot>
		</main>
	</div>
</template>

<style scoped></style>
